import { Col, Divider, Form, Input, Row } from "antd";
import {
  DepartamentoSelect,
  DistritoSelect,
  ProvinciaSelect,
} from "../../generales/ubigeos";

export const EmpleadoUbicacion = () => {
  const form = Form.useFormInstance();
  const departamento = Form.useWatch(["persona", "departamento"], form);
  const provincia = Form.useWatch(["persona", "provincia"], form);
  return (
    <>
      <Divider orientation="center" style={{ margin: "8px 0" }}>
        Ubicación
      </Divider>
      <Row gutter={[8, 8]}>
        <Col xs={24} sm={24} md={24} lg={24} xl={20}>
          <Form.Item
            label="Dirección"
            name={["persona", "direccion"]}
            rules={[{ required: true, message: "La dirección es obligatoria" }]}
          >
            <Input name="direccion" placeholder="Ingrese dirección" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[8, 8]}>
        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
          <Form.Item
            label="Departamento"
            name={["persona", "departamento"]}
            rules={[
              { required: true, message: "El departamento es obligatorio" },
            ]}
          >
            <DepartamentoSelect
              placeholder="[-Seleccione-]"
              style={{ width: "100%" }}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
          <Form.Item
            label="Provincia"
            name={["persona", "provincia"]}
            rules={[{ required: true, message: "La provincia es obligatoria" }]}
          >
            <ProvinciaSelect
              departamento={departamento}
              placeholder="[-Seleccione-]"
              style={{ width: "100%" }}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
          <Form.Item
            label="Distrito"
            name={["persona", "ubigeodireccion"]}
            rules={[{ required: true, message: "El distrito es obligatorio" }]}
          >
            <DistritoSelect
              provincia={provincia}
              placeholder="[-Seleccione-]"
              style={{ width: "100%" }}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};
